module.exports = __webpack_public_path__ + "static/z_tall_kurt_bestor-99fa0a19d9fff7916fa5788719fdadb3.jpg";